import script from "./InfoToast.vue?vue&type=script&lang=ts"
export * from "./InfoToast.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__